var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C4.067 0 0 2.992 0 8c0 4.6 6.544 11.327 7.29 12.08a1 1 0 0 0 1.42 0C9.456 19.327 16 12.6 16 8c0-5.008-4.067-8-8-8Zm0 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z",
    fill: "#000"
  })));
};

export default SvgPin;